<template>
    <div>
        <actionable-card v-if="!exerciseFinished"
            title="MultiMe"
            title-variant="primary"
            :description="trans('courses.multicircle_exercise.card_text')"
            :button-text="trans('courses.multicircle_exercise.start_exercise')"
            :secondary-button-text="trans('courses.multicircle_exercise.see_tutorial')"
            secondary-button-variant="link"
            buttonSize="sm"
            @primaryClicked="openModal"
            @secondaryClicked="showTutorial"
        >
            <template v-slot:icon>
                <multi-circle />
            </template>
            <template v-slot:extra-body>
                <small class="text-opacity mb-1 d-block">{{ trans('courses.multicircle_exercise.collaboration_with') }}</small>
                <b-img src="/images/multicircle/Kellogg_logo.svg" v-bind="{ width: 146, left: true }" />                        
            </template>
        </actionable-card>
        <multi-me-result-card v-else
            :title="trans('courses.multicircle_exercise.results.card_title')"
            :description="`${trans('courses.multicircle_exercise.results.result_before')} ${Object.keys(currentExercise.roles).length} ${trans('courses.multicircle_exercise.results.result_after')}`"
            :date="currentExercise.date"
            :button-text="trans('courses.multicircle_exercise.results.see_results')"
            :secondary-button-text="isAdmin ? trans('courses.multicircle_exercise.remove_data') : ''"
            secondary-button-variant="link"
            :result-id="currentExercise.id"
            @primaryClicked="openResult"
            @secondaryClicked="deleteExercise(currentExercise.id)"
        />
        <multi-me-modal :is-admin="isAdmin" :is-in-course="true" @exerciseCompleted="closeModal" @goToResult="openResult"/>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

import MultiMeModal from "../organisms/multime/MultiMeModal";
import ActionableCard from "../molecules/cards/ActionableCard";
import MultiMeResultCard from "../organisms/multime/MultiMeResultCard";
import MultiCircle from "../atoms/MultiCircle";

export default {
    name: "MultiMeExerciseContainer",
    components: {MultiMeModal, ActionableCard, MultiMeResultCard, MultiCircle},
    props:{
        pageId: String,
        exercise: Object,
        isFirstExercise: Boolean,
        isAdmin: Boolean,
        traits: Array
    },
    mounted(){
        let trackingData;

        if(this.$route.name === 'page'){
            trackingData = {"type": 'master', "current-role": this.currentRole}
        }else{
            trackingData = {"type": 'stream', "stream-id": this.$route.params.id}
        }

        this.setTrackingData(trackingData);

        trackEvent('MulticircleExerciseView', trackingData);

        this.clearExercise();

        if(this.exercise && this.exercise.head){
            this.setPageExercise(this.exercise);
        }

        this.setCharacteristicsList(this.traits)
    },
    methods:{
        ...mapActions('multime',['setPageExercise','deleteExercise', 'createExercise', 'fetchExercises']),
        ...mapMutations('multime',['clearExercise', 'setCharacteristicsList', 'setTrackingData']),

        async openModal(){
            trackEvent('MulticircleExerciseStart', this.trackingData);

            if(this.currentExercise.id === null){
                let payload;
                if(this.pageId){
                    payload = {
                        type: "master_page",
                        pageId: this.pageId
                    }
                }else{
                    payload = {
                        type: "stream_page",
                        miu_id: this.$route.params.elementId,
                        ale_id: this.$route.params.aleId,
                        stream_localization: this.$route.params.localisation,
                        stream_id: this.$route.params.id,
                    }
                }
                await this.createExercise(payload);
            }
            this.$bvModal.show('multime-modal')
        },
        closeModal(){
            trackEvent('MultiMeBacktoLearning', this.trackingData);

            this.$bvModal.hide('multime-modal')
        },
        openResult(){
            trackEvent('MultiMeShowResult', this.trackingData);

            window.open(`/multime/result/${this.currentExercise.id}`,'_blank');
        },
        showTutorial(){
            trackEvent("MulticircleLearnMoreClick", {
                "current-role": this.currentRole,
            });

            if(typeof(Intercom) !== 'undefined'){
                Intercom('startTour', this.tourId);
            }
        }
    },
    computed:{
        ...mapGetters({
            exerciseFinished: 'multime/isExerciseFinished',
            currentExercise: 'multime/getCurrentExercise',
            trackingData: 'multime/getTrackingData',
            tourId: 'multime/getTour'
        })
    }
}
</script>
